export default "__VITE_ASSET__cb7ef48f__"